export default "__VITE_ASSET__01f2b6ee__"